import createActions from 'utils/redux/createActions'

export default createActions([
    'SECTION_EXPAND'
])



// WEBPACK FOOTER //
// ./src/actions/sections.js